<template>
  <span class="font-medium">{{ value() }}</span>
</template>

<script>
export default {

  methods: {
    value () {
      // if the current column is the same as first column then force set it's value to 'Total'
      const columns = this.params.columnApi.getAllColumns()

      if (!columns) {
        return
      }

      const firstColumnId = columns[0].colId

      const currentColumnId = this.params.column.colId

      if (firstColumnId === currentColumnId) {
        // set the value to 'Total'
        return 'Total'
      }

      const value = Number(this.params.data[currentColumnId])
      const isNumber = !Number.isNaN(value)
      if (this.params.data[currentColumnId] === null || !isNumber) {
        return ''
      }
      // else return the original value received from the backend formatted
      // as numbers instead of calculated one OR return empty string
      switch (this.params.column.colDef.sign) {
      case '%':
        return this.$options.filters.addComma(value, '%')
      case '$':
        return this.$options.filters.addComma(value, '$')
      default:
        return this.$options.filters.addComma(value)
      }
    }
  }
}
</script>
